import { Page } from '@/components/layout/page/page.tsx'
import { Courses } from '@/modules/course/ui/Courses'

export const CoursesView = () => {
  return (
    <Page
      className="mb-6"
      title="Course"
      titleClassName="text-3xl"
    >
      <Courses />
    </Page>
  )
}
